import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex)


const store = new Vuex.Store({
    // 実際のデータ
    state: {
        initialized: false,
        entryList: [],
        currentId: null,
        catEra: null,
        catProduct: null,
        catEntry: null
    },
    getters: {
        initialized(state) { return state.initialized; },
        entryList(state) { return state.entryList; },
        currentId(state) { return state.currentId; },
        catEra(state) { return state.catEra; },
        catProduct(state) { return state.catProduct; },
        catEntry(state) { return state.catEntry; },
        filteredEntryList(state) {
            const result = [];
            const copiedEntryList = JSON.parse(JSON.stringify(state.entryList));
            let keys = Object.keys(copiedEntryList);
            keys.sort();

            for (let i = 0; i < keys.length; i++) {
                const key = keys[i];
                const entries = copiedEntryList[key].entries;
                const west_cal = copiedEntryList[key].west_cal;
                const jp_cal = copiedEntryList[key].jp_cal;
                let show_count = 0;
                for (let j = 0; j < entries.length; j++) {
                    let item = entries[j];
                    if (
                        (state.catEra && item.era !== state.catEra) ||
                        (state.catProduct && item.cat_product !== state.catProduct) ||
                        (state.catEntry && item.cat_entry !== state.catEntry)
                    ) {
                        entries.splice(j, 1);
                        j--;
                    }else{
                        if(entries[j].flg_list_show == 1){
                            show_count++;
                        }
                    }
                };
                if (entries.length > 0) {
                    result.push(
                        {'id':key, 'west_cal': west_cal, 'jp_cal': jp_cal, 'show_count': show_count, 'entries': entries}
                    );
                }
                
            };
            return result;
        },
        currentEntry(state, getters) {
            const entryList = getters.filteredEntryList;
            let keys = Object.keys(entryList);
            let result = {
                nextNo: null,
                prevNo: null,
                entry: null
            }

            if (state.currentId) {
                let prevNo = null;
                let nextNo = null;
                let entry = null;

                nestedloop:
                for (let i = 0; i < keys.length; i++) {
                    const key = keys[i];
                    const entries = entryList[key].entries;
                    for (let j = 0; j < entries.length; j++) {
                        let item = entries[j];
                        if (parseInt(item.no) === parseInt(state.currentId)) {
                            entry = item;
                        }else if(entry === null){
                                prevNo = item.no;
                        }else if(entry !== null && nextNo === null){
                            nextNo = item.no;
                            break nestedloop;
                        }
                        
                    };
                };

                result.prevNo = prevNo;
                result.nextNo = nextNo;
                result.entry = entry;
            }
            return result;
        }
    },
    mutations: {
        entryList(state, payload) {
            state.initialized = true;
            state.entryList = payload.entryList;
        },
        currentId(state, payload) {
            state.currentId = payload.currentId;
        },
        searchTerm(state, payload) {
            state.catEra = payload.catEra;
            state.catProduct = payload.catProduct;
            state.catEntry = payload.catEntry;
        }
    },
    actions: {
        setCurrentId({ commit }, currentId) {
            commit('currentId', { currentId });
        },
        setEntryList({ commit }, entryList) {
            commit('entryList', { entryList });
        }
    },
    plugins: [
        createPersistedState({
          key: 'morinaga-museum-history',
          paths: ['catEra', 'catProduct', 'catEntry'],
          storage: window.sessionStorage,
        }),
    ]
});

/*
window.addEventListener('beforeunload', () => {
    window.sessionStorage.removeItem('morinaga-museum-history');
})
*/

export default store;


// WEBPACK FOOTER //
// ./src/store.js